import { z } from 'zod';
import type { AppChat, TipoNotificacao } from '../enums/dominios';

// Avisos do sistema (RQ-NTF-001): registrados para a pessoa, aparecem no sino com motivo e link para o item.

/** Prioridade de avisos e mensagens: número menor é mais urgente. */
export const PRIORIDADE = { urgente: 10, padrao: 100, podeEsperar: 200 } as const;

/** Para onde o aviso leva: o quadro e, quando houver, a licitação, o convite a aprovar ou o post-it em foco. */
export type LinkNotificacaoDto = { empresaUuid: string; quadroUuid: string; processoUuid: string | null; conviteUuid: string | null; notaUuid: string | null };

export type NotificacaoDto = {
  uuid: string;
  tipo: TipoNotificacao;
  titulo: string;
  motivo: string;
  prioridade: number;
  link: LinkNotificacaoDto | null;
  /** ISO 8601 (UTC). */
  criadaEm: string;
  lidaEm: string | null;
};

export type NotificacoesDto = { naoLidas: number; notificacoes: NotificacaoDto[] };

/** Marca como lidas as informadas; sem lista, todas. */
export const esquemaMarcarLidas = z.object({ uuids: z.array(z.string().uuid()).max(500).optional() });
export type MarcarLidasEntrada = z.infer<typeof esquemaMarcarLidas>;

// Canais externos da pessoa (RQ-MSG-007): ela mesma vincula o Telegram pelo link do bot.

export type CanalVinculadoDto = { app: AppChat; vinculadoEm: string };
/** `telegramDisponivel`: o bot está configurado neste ambiente. */
export type CanaisDto = { canais: CanalVinculadoDto[]; telegramDisponivel: boolean };
/** Link do bot com o código de uso único; vale até `expiraEm`. */
export type VinculoTelegramDto = { link: string; expiraEm: string };
